/**
 * Joshua Alele-Beals
 * joshbeals22@gmail.com
 * github.com/joshBeals
 */

import numberToWords from "./numberToWords";

function getWithin(n) {
    return "within" + numberToWords(n);
}

export default getWithin;